import { CombinedQualification } from '../../../shared/interfaces/qualification.interface';
import { NestingQualification } from '../../../shared/interfaces/quota-nesting.interface';
import {
  NestedQuota,
  QuotaPayload,
} from '../../../shared/interfaces/quota.interface';
import { BuyerSurveyResponse } from '../../../shared/interfaces/survey.interface';

export interface MultiQuotaNestingData {
  qualifications: CombinedQualification[];
  completes: number;
  nestedQuotas: NestedQuota[];
  quotas: QuotaPayload[];
  surveyDetails: BuyerSurveyResponse;
}

export interface MultiQuotaNestingReturn {
  canceled: boolean;
  quotas: NestedQuota[];
}

export type NestingGroupState = 'pending' | 'created';
export type NestingGroupTitleState = 'view' | 'edit';
export interface EachNestingGroupData {
  uniqueId: string;
  id: string;
  state: NestingGroupState;
  quotas: NestedQuota[];
  qualifications: NestingQualification[];
  selectedQualifications: NestingQualification[];
  titleState: NestingGroupTitleState;
  qualificationSelection: boolean;
  canResetTable: boolean;
}

export function isNestedQuota(value: unknown): value is NestedQuota {
  return (
    typeof value === 'object' && value !== null && 'buyer_quota_id' in value
  );
}
